export class Portfolio {
    Id: number;
    Category: string;
    CategoryID: number;
    StudentID: number;
    Name: string;
    Description: string;
    Size: any;
    SizeUnit: string;
    SortSize: number;
    AYIdentifier: string;
    Added: string;
    AddedBy: string;
    FileBase64: string;
    FileMimeType: string;
    FilePath: string;
    RecentAccessHistory: string;
}
